import React from "react";

function Features() {
  return (
    <div>
      <section className="w-100 float-left design-con position-relative">
        <div className="wrapper2">
          <div className="design-box">
            <div className="design-box-content">
              <h2 data-aos="fade-up" data-aos-duration={600}>
                Why Choose DNET?
              </h2>
              <p data-aos="fade-up" data-aos-duration={600}>
                Our Tools Simplify And Accelerate Workflows, Foster Creativity,
                And Enable Others To Create New Products.
              </p>

              <div className="d-flex r">
                <a
                  className="button-1 px-5 my-2 my-lg-0"
                  href="#"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="dots_border" />

                  <span className="text_button m-0">Get Started</span>
                </a>
              </div>
            </div>
            <div className="design-box-item">
              <div className="design-service">
                <div
                  className="collection-box"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <figure>
                    <img
                      src="../assets/images/img/ai_powered_yield_optimization.svg"
                      width={60}
                      alt="collection-img1"
                    />
                  </figure>
                  <h4> AI-Powered Yield Optimization</h4>
                </div>
                <div
                  className="collection-box"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <figure>
                    <img
                      src="../assets/images/img/fast_&_secure_transactions.svg"
                      width={60}
                      alt="collection-img1"
                    />
                  </figure>
                  <h4> Fast & Secure Transactions </h4>
                </div>
                <div
                  className="collection-box"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <figure>
                    <img
                      src="../assets/images/img/low_entry_barrier.svg"
                      width={60}
                      alt="collection-img1"
                    />
                  </figure>
                  <h4> Low Entry Barrier</h4>
                </div>
                <div
                  className="collection-box"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <figure>
                    <img
                      src="../assets/images/img/transparent_&_trustless.svg"
                      width={60}
                      alt="collection-img1"
                    />
                  </figure>
                  <h4> Transparent & Trustless</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Features;
